export default {
  scorecard: {
    title: 'Kartu Skor',
    content: 'Konten',
    award: 'Penghargaan ESG',
  },
  list_table_filter: {
    table_buyer_company_name: 'Pembeli',
    table_question_group_name: 'Survei',
    table_status: 'Status',
    table_issue_at: 'Tanggal terbit',
    table_sustaina_rate: 'Peringkat ESG',
    table_esg_score: 'Skor ESG',
    table_operation: 'Pengoperasian',
    displayed_items_number: 'Tampilkan {start} hingga {end} dari {total} perusahaan',
    displayed_items_number_empty: 'Tampilkan 0 dari 0 perusahaan',
    no_data_display: 'Data tidak dapat ditemukan',
    csv_modal_title: 'Silakan pilih item yang akan diekspor dalam CSV',
    csv_modal_answer_status_title: 'Status Jawaban',
    csv_modal_answer_status_text: 'Daftar status jawaban pemasok ekspor.',
    csv_modal_answer_title: 'Jawaban (1 file per 500 perusahaan)',
    csv_modal_answer_title_by_individual_company: 'Jawaban (1 file per perusahaan)',
    csv_modal_answer_text: 'Jawaban pemasok akan dikeluarkan dalam 1 file per 500 perusahaan.',
    csv_modal_answer_text_by_individual_company: 'Jawaban pemasok akan dikeluarkan dalam 1 file per 1 perusahaan.',
    csv_modal_score_title: 'Skor',
    csv_modal_score_text: 'Ekspor peringkat dan skor pemasok.',
    csv_modal_answer_heading: 'Judul',
    csv_modal_answer_heading_supplier: 'Pemasok',
    csv_modal_answer_heading_question: 'Pertanyaan',
    csv_modal_answer_additional: 'Item Tambahan',
    csv_modal_answer_additional_note: 'Catatan',
    csv_modal_answer_additional_file: 'Nama File yang Dilampirkan',
    csv_modal_cautionary_note_title: 'Pemberitahuan',
    csv_modal_cautionary_note_content: '・File output termasuk "status jawaban", "jawaban" dan "skor" untuk {questionGroupName}.\n・Untuk "status jawaban", semua perusahaan yang terdaftar disertakan, terlepas dari status jawaban mereka pada survei.\n・Untuk "jawaban" dan "skor", perusahaan dengan status jawaban “Sedang Berlangsung” tidak disertakan dalam file output.\n・Jumlah maksimum perusahaan yang dapat ditampilkan dalam satu file CSV untuk "jawaban" dan "skor" adalah 1.000.\n・File CSV akan dikirim ke alamat email akun yang saat ini sedang login.',
    csv_modal_sent_mail_section_one: 'Permintaan ekspor CSV Anda telah diterima.',
    csv_modal_sent_mail_section_two: 'Silakan tunggu beberapa saat hingga email berisi URL untuk mengunduh CSV dikirim ke alamat email Anda.',
    csv_modal_sent_mail_section_three: 'Jika Anda tidak menerima email dalam waktu 30 menit, silakan coba lagi.',
  },
  overall_score_section: {
    card_title: 'Konten Survei',
    score: 'Skor',
    esg_score: 'Skor ESG',
    esg_rating: 'Peringkat ESG',
    esg_score_tip: 'Skor ESG adalah evaluasi aktivitas ESG perusahaan Anda.Skor dihitung berdasarkan jawaban Anda pada survei ASUENE ESG.',
    esg_rating_tip: 'Peringkat ESG adalah evaluasi absolut terhadap tingkat aktivitas ESG perusahaan Anda yang dikategorikan pada skala tujuh poin dari AAA hingga CCC berdasarkan skor ESG Anda.',
    evaluator_advice_title: 'Komentar Penilaian',
    list_header_buyer_company_name: 'Pembeli',
    list_header_supplier_company_name: 'Pemasok',
    list_header_question: 'Survei',
    list_header_create_at: 'Tanggal terbit',
    list_header_deadline: 'Tanggal kedaluwarsa',
    list_header_industry: 'Industri',
    list_header_company_scale: 'Jumlah karyawan',
    list_header_status: 'Status',
    download_csv: 'Ekspor CSV',
    download_pdf: 'Ekspor PDF',
    // csv_title_for_buyer: "",
    csv_title_for_supplier: 'ASUENE ESG',
    answer: '@:upload_common.question_group_download_answered_csv_title',
    download_answer_description: 'Unduh jawaban dalam bentuk csv.',
    answer_pdf: '@:upload_common.question_group_download_answered_pdf_title',
    download_answer_pdf_description: 'Unduh jawaban dalam format pdf.',
    scorecard_pdf: 'Kartu Skor(PDF)',
    download_scorecard_pdf_description: 'Unduh skor dalam format pdf.',
    feedback: 'Umpan balik penilaian',
    attached_file: "@:{'improvementplans.attached_file'}",
    download_feedback_description: 'Dokumen akan diunduh dalam bentuk PDF.',
    award_medal_svg: 'Penghargaan ESG(SVG)',
    download_award_medal_svg_description: 'Unduh sebagai gambar SVG',
    award_medal_png: 'Penghargaan ESG(PNG)',
    download_award_medal_png_description: 'Unduh sebagai gambar PNG',
    pdf_modal_sent_mail_section_one: 'Permintaan ekspor PDF Anda telah diterima.',
    pdf_modal_sent_mail_section_two: 'Silakan tunggu beberapa saat hingga email berisi URL untuk mengunduh PDF dikirim ke alamat email Anda.',
    pdf_modal_sent_mail_section_three: 'Jika Anda tidak menerima email dalam waktu 30 menit, silakan coba lagi.',
  },
  category_score_section: {
    card_title: 'Skor Berdasarkan Kategori',
    tip: 'Skor kategori adalah skor untuk kategori lingkungan, sosial, dan tata kelola perusahaan Anda. Pembobotan pertanyaan pada setiap kategori bervariasi menurut perusahaan.',
    policy: 'Kebijakan',
    action: 'Tindakan',
    result: 'Hasil',
  },
  score_by_category_compared_section: {
    card_title: 'Bandingkan skor berdasarkan kategori',
    get_score_by_category: 'Skor Kategori Perusahaan Anda',
    esg_evaluated_all_companies_average: 'Semua perusahaan yang dinilai oleh Asene ESG',
    tip: 'Ini adalah skor rata-rata perusahaan yang menjawab survei yang sama.',
  },
  strengths_advice_section: {
    card_title: 'Kekuatan dan perbaikan',
    strong_point: 'Kekuatan',
    advice: 'perbaikan',
    policies: 'Kebijakan',
    action: 'Tindakan',
    result: 'Hasil',
    no_results_for_this_category: 'Tidak ada hasil untuk Kategori ini.',
    risk: 'Risiko',
    indicator: 'Indikator',
    content: 'Konten',
    operation: 'Pengoperasian',
  },
  preview: {
    go_back_to_scorecard: 'Kembali ke Kartu Skor',
  },
  buyer_scorecard: {
    overview_card_title: '@:overall_score_section.card_title',
    score_card_title: '@:list_table_filter.csv_modal_score_title',
    evaluation_comment_card_title: 'Ringkasan skor keseluruhan',
    category_card_tabs_risk: '@:improvementplans.risk',
    category_card_tabs_content: '@:scorecard.content',
    category_card_tabs_operation: '@:improvementplans.operation',
    category_card_score_title: '@:list_table_filter.csv_modal_score_title',
    category_card_score_average: 'Skor Rata-Rata: ',
    category_card_score_no_score: 'Tidak berlaku',
    category_card_score_earned_score: 'Skor Anda',
    category_card_details_list_title: 'Komentar Penilaian',
    category_card_details_no_score_tip: 'Kategori ini tidak termasuk dalam penilaian.',
    category_card_score_average_score: 'Skor rata-rata semua perusahaan',
    category_card_details_title: 'Ringkasan skor kategori',
    category_card_details_strengths: '@:strengths_advice_section.strong_point',
    category_card_details_indicated_points: '@:strengths_advice_section.advice',
    no_score_tip: 'Item ini tidak berlaku karena survei dinilai berdasarkan logika pembeli.',
    buyer_evaluate_tip: 'Item ini dinilai berdasarkan logika pembeli. Tidak dinilai berdasarkan logika Penilaian ESG Asuene.',
    answer_rejection_notification: 'Anda menerima permintaan penarikan baru',
    answer_rejection_modal_title: 'Kirim kembali kiriman',
    answer_rejection_modal_text: 'Kirim kembali komentar',
    answer_rejection_modal_content: 'Jawaban {companyName} akan dikirim kembali. \nSilakan tulis komentar untuk alasan pengiriman kembali',
    answer_rejection_dialog_content: 'Jawaban {companyName} telah dikirim kembali',
    answer_rejection_button_title: 'Kirim kembali',
  },
}
